export default import.meta.ROLLDOWN_FILE_URL_cp$3vJo41T1cpHN8Y1mXiQ